import { ApplicationState } from '../../store/rootReducer';

export const getIsSomeModalOpened = (state: ApplicationState): boolean => {
  return state.modalDialogManager.modals.some(() => true);
};
